module.exports = __webpack_public_path__ + "img/run-grey.7a47817b.svg";